var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29845 11.0202L10.9318 6.3869C10.9873 6.33134 11.0262 6.27579 11.0485 6.22023C11.0707 6.16467 11.0818 6.10356 11.0818 6.0369C11.0818 5.97023 11.0707 5.90912 11.0485 5.85356C11.0262 5.79801 10.9873 5.74245 10.9318 5.6869L6.28179 1.0369C6.1929 0.948009 6.08179 0.903564 5.94845 0.903564C5.81512 0.903564 5.69845 0.953564 5.59845 1.05356C5.49845 1.15356 5.44845 1.27023 5.44845 1.40356C5.44845 1.5369 5.49845 1.65356 5.59845 1.75356L9.38179 5.5369H1.11512C0.970676 5.5369 0.851233 5.58412 0.756788 5.67856C0.662344 5.77301 0.615121 5.89245 0.615121 6.0369C0.615121 6.18134 0.662344 6.30079 0.756788 6.39523C0.851233 6.48968 0.970676 6.5369 1.11512 6.5369H9.38179L5.58179 10.3369C5.4929 10.4258 5.44845 10.5369 5.44845 10.6702C5.44845 10.8036 5.49845 10.9202 5.59845 11.0202C5.69845 11.1202 5.81512 11.1702 5.94845 11.1702C6.08179 11.1702 6.19845 11.1202 6.29845 11.0202Z",
    fill: "#1E2329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3f51268b.svg";
export { ForwardRef as ReactComponent };